export const getSaveButtonTitle = (t, isNew, active) => {
  if (isNew) {
    return active ? t('common.creating') : t('common.create');
  } else {
    return active ? t('common.saving') : t('common.save');
  }
};
